var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsEnum, IsInt, IsNumber, IsOptional, IsString, Max, Min, } from 'class-validator';
import { OfficeProductLineItemFullSizeDto } from '../../custom-office-product-line-item/index.js';
import { OfficeProductType } from '../enums/office-product-type.enum.js';
export class CreateOfficeProductDto {
    /**
     * The display name of the office product.
     */
    name;
    /**
     * The id of the office
     */
    officeId;
    /**
     * The price of the office product in euro-cents.
     */
    price;
    /**
     * The short description of the office product.
     */
    description;
    /**
     * True if the office product is visible for patients.
     */
    visible;
    /**
     * The type of the office product.
     */
    type;
    /**
     * The number of therame video calls included in the product.
     */
    therameVideoCallCount = null;
    /**
     * The number of therame exercise programs included in the product.
     */
    therameExerciseProgramCount = null;
    /**
     * The number of days until the product expires.
     */
    expirationDays;
    officeProductLineItems;
}
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], CreateOfficeProductDto.prototype, "name", void 0);
__decorate([
    Expose(),
    IsString(),
    IsOptional(),
    __metadata("design:type", String)
], CreateOfficeProductDto.prototype, "officeId", void 0);
__decorate([
    Expose(),
    IsNumber(),
    Min(1),
    Max(9999999900),
    __metadata("design:type", Number)
], CreateOfficeProductDto.prototype, "price", void 0);
__decorate([
    Expose(),
    IsString(),
    __metadata("design:type", String)
], CreateOfficeProductDto.prototype, "description", void 0);
__decorate([
    Expose(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], CreateOfficeProductDto.prototype, "visible", void 0);
__decorate([
    IsEnum(OfficeProductType),
    Expose(),
    __metadata("design:type", String)
], CreateOfficeProductDto.prototype, "type", void 0);
__decorate([
    Expose(),
    IsInt(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateOfficeProductDto.prototype, "therameVideoCallCount", void 0);
__decorate([
    Expose(),
    IsInt(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateOfficeProductDto.prototype, "therameExerciseProgramCount", void 0);
__decorate([
    Expose(),
    IsInt(),
    Min(1),
    Max(365),
    __metadata("design:type", Number)
], CreateOfficeProductDto.prototype, "expirationDays", void 0);
__decorate([
    Expose(),
    IsArray(),
    IsOptional(),
    Type(() => OfficeProductLineItemFullSizeDto),
    __metadata("design:type", Array)
], CreateOfficeProductDto.prototype, "officeProductLineItems", void 0);
//# sourceMappingURL=create-office-product.dto.js.map